import { render, staticRenderFns } from "./modal-info-sent-mail.vue?vue&type=template&id=6ed696a6&scoped=true"
import script from "./modal-info-sent-mail.vue?vue&type=script&lang=js"
export * from "./modal-info-sent-mail.vue?vue&type=script&lang=js"
import style0 from "./modal-info-sent-mail.vue?vue&type=style&index=0&id=6ed696a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed696a6",
  null
  
)

export default component.exports